interface IAdmin {
  post: {
    balance: string;
    card: string;
    accountReset: string;
    energyReset: string;
  };
}

interface IAuth {
  get: {
    loginByNier: string;
  };
  post: {
    refreshToken: string;
    logout: string;
  };
}

interface IAccount {
  get: {
    accountInfo: string;
  };
}
interface ICharacter {
  get: {
    characterList: string;
  };
  post: {
    slot: string;
    skill: string;
    energyReplenishment: string;
    expirenceReplenishment: string;
    // skill: {
    //   redetermine: string;
    // };
    // slot: {
    //   unlock: string;
    //   fill: string;
    //   freeUp: string;
    // };
  };
}

interface IConfiguration {
  get: {
    configuration: string;
  };
}

interface ICard {
  get: {
    cardState: string;
  };
}

interface ICity {
  get: {
    city: string;
  };
}

interface IBuildingCraft {
  post: {
    startCraft: string;
    collect: string;
    accelerate: string;
  };
}
interface IBuildingEnergyCraft {
  post: {
    startCraft: string;
  };
}
interface IGlobalMap {
  post: {
    matrix: string;
    unlock: string;
  };
}
interface IDailyQuestEndpoints {
  get: {
    getDailyQuestList: string;
  };
  post: {
    dailyQuestAction: string;
  };
}
interface IReferral {
  get: {
    referral: string;
  };
}
export const adminEndpoints: IAdmin = {
  post: {
    balance: 'admin/balance',
    card: 'admin/card',
    accountReset: 'admin/account/reset',
    energyReset: 'admin/character/energy/reset',
  },
};

export const checkApiHealthStatusEndpoint: string = 'health-check';

export const authEndpoints: IAuth = {
  get: {
    loginByNier: 'authentication/near/login',
  },
  post: {
    refreshToken: 'authentication/refresh/',
    logout: 'authentication/logout',
  },
};

export const accountEndpoints: IAccount = {
  get: {
    accountInfo: 'state/account',
  },
};

export const characterEndpoints: ICharacter = {
  get: {
    characterList: 'state/character',
  },
  post: {
    slot: 'character/slot/',
    skill: 'character/slot/skill/',
    energyReplenishment: 'character/energy/replenishment',
    expirenceReplenishment: 'character/experience/replenishment',
    // skill: {
    //   redetermine: 'character/slot/skill/redetermine',
    // },
    // slot: {
    //   unlock: 'character/slot/unlock',
    //   fill: 'character/slot/fill',
    //   freeUp: 'character/slot/free-up',
    // },
  },
};

export const configurationEndpoints: IConfiguration = {
  get: {
    configuration: 'state/configuration',
  },
};

export const cardEndpoints: ICard = {
  get: {
    cardState: 'state/card',
  },
};

export const cityEndpoints: ICity = {
  get: {
    city: 'state/city/',
  },
};

export const buildingCraftEndpoints: IBuildingCraft = {
  post: {
    startCraft: 'building/craft/resource/start',
    collect: 'building/craft/resource/collect',
    accelerate: 'building/craft/resource/accelerate',
  },
};
export const buildingEnergyCraftEndpoints: IBuildingEnergyCraft = {
  post: {
    startCraft: 'building/craft/energy/start',
  },
};
export const dailyQuestEndpoints: IDailyQuestEndpoints = {
  get: {
    getDailyQuestList: '/task/daily',
  },
  post: {
    dailyQuestAction: 'building/task/daily/',
  },
};
export const globalMapEndpoints: IGlobalMap = {
  post: {
    matrix: 'map/land/matrix',
    unlock: 'map/land/unlock',
  },
};
export const referralEndpoints: IReferral = {
  get: {
    referral: 'state/referral',
  },
};
